import { AppState } from 'src/redux/modules';
import { enrol as enrolRequest, Variation } from 'src/helpers/api/ab';
import { Dispatch } from 'redux';

export interface AbState {
  us_prelaunch?: Variation;
  donate_share_prompt?: Variation;
}

type Slug = keyof AbState;

interface EnrolActionRequest {
  type: 'AB_ENROL_REQUEST';
  payload: Slug;
}

interface EnrolActionSuccess {
  type: 'AB_ENROL_SUCCESS';
  payload: {
    slug: Slug;
    enrolledIn: Variation;
  };
}

interface EnrolActionFailure {
  type: 'AB_ENROL_FAILURE';
  payload: { err: Error; slug: Slug };
}

type EnrolAction = EnrolActionRequest | EnrolActionSuccess | EnrolActionFailure;

export const enrol = (slug: Slug) => async (
  dispatch: Dispatch<AppState>,
  getState: () => AppState
): Promise<void> => {
  const state = getState();

  if (state.ab[slug]) {
    return;
  }

  dispatch({ type: 'AB_ENROL_REQUEST', payload: slug });

  try {
    const enrolledIn = await enrolRequest(`cf_${slug}`);

    dispatch({ type: 'AB_ENROL_SUCCESS', payload: { slug, enrolledIn } });
  } catch (err) {
    dispatch({ type: 'AB_ENROL_FAILURE', payload: { slug, err } });
  }
};

export default (state = {}, action: EnrolAction): AbState => {
  switch (action.type) {
    case 'AB_ENROL_SUCCESS':
      return {
        ...state,
        [action.payload.slug]: action.payload.enrolledIn,
      };

    case 'AB_ENROL_FAILURE':
      return {
        ...state,
        [action.payload.slug]: 'A' as Variation,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/modules/ab.ts